/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Flow_MarkerInputs */

const en_services_flow_marker = /** @type {(inputs: Services_Flow_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example`)
};

const lv_services_flow_marker = /** @type {(inputs: Services_Flow_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piemērs`)
};

/**
* | output |
* | --- |
* | "Example" |
*
* @param {Services_Flow_MarkerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_flow_marker = /** @type {((inputs?: Services_Flow_MarkerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Flow_MarkerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_flow_marker(inputs)
	return en_services_flow_marker(inputs)
});